'use strict';

var isISODate = function isISODate(value) {
  try {
    var val = value;

    if (val && typeof val.toISOString === 'function') {
      val = val.toISOString();
    }

    var isoformat = '^\\d{4}-\\d{2}-\\d{2}' + // Match YYYY-MM-DD
    '((T\\d{2}:\\d{2}(:\\d{2})?)' + // Match THH:mm:ss
    '(\\.\\d{1,6})?' + // Match .sssss
    '(Z|(\\+|-)\\d{2}:\\d{2})?)?$'; // Time zone (Z or +hh:mm)

    var matcher = new RegExp(isoformat);

    return typeof val === 'string' && matcher.test(val) && !isNaN(Date.parse(val));
  } catch (e) {
    return false;
  }
};

var isEmail = function isEmail(value) {
  return (/\S+@\S+\.\S+/.test(value)
  );
};

var isNumber = function isNumber(value) {
  return !isNaN(value);
};

var isPhone = function isPhone(value) {
  return (/[0-9]{10,}/.test(value && value.replace(/[^0-9]/g, ''))
  );
};

// must contain capital letter, number, and 6 characters
var isValidPassword = function isValidPassword(value) {
  return (/(?=.*[A-Z]+)(?=.*[0-9]+)(\w+){6,}/g.test(value)
  );
};

var isString = function isString(value) {
  return typeof value === 'string';
};

var isWebUrl = function isWebUrl(value) {
  return (/\S+\.\S+/.test(value)
  );
};

var minLength = function minLength(min) {
  return function (value) {
    return isNaN(value) || value >= min;
  };
};

var validate = Object.freeze({
	isISODate: isISODate,
	isEmail: isEmail,
	isNumber: isNumber,
	isPhone: isPhone,
	isValidPassword: isValidPassword,
	isString: isString,
	isWebUrl: isWebUrl,
	minLength: minLength
});

/**
 * Compose fina;-form validation functions
 *
 * example: composeValidate(required, email)
 *
 * @param args {Array<Function>}
 * @returns {Function|undefined}
 */
var composeValidate = function composeValidate() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (!Array.isArray(args)) return undefined;

  return function (value) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var validate = _step.value;

        var validateReturn = validate(value);

        if (validateReturn) return validateReturn;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
};

var isoDate = function isoDate(val) {
  return isISODate(val) ? undefined : 'must be valid date';
};

var email = function email(val) {
  return isEmail(val) ? undefined : 'must be an email';
};

var password = function password(val) {
  return isValidPassword(val) ? undefined : 'not a valid password';
};

var phone = function phone(val) {
  return isPhone(val) ? undefined : 'not a valid phone #';
};

// an empty array is not valid
var required = function required(val) {
  if (Array.isArray(val)) return val.length ? undefined : 'required';

  return val ? undefined : 'required';
};

var url = function url(val) {
  return isWebUrl(val) ? undefined : 'not a valid url';
};

var formValidate = Object.freeze({
	composeValidate: composeValidate,
	isoDate: isoDate,
	email: email,
	password: password,
	phone: phone,
	required: required,
	url: url
});

/**
 * This function should be called at the beginning of the app initialization
 * and the account settings should be passed here, ie: organization/user settings.
 *
 * This function will create a singleton pattern settings object and will be used
 * by all other util or services exported from this project. An example would be
 * the organization's datetime format is set to 24hr - this configure() call would
 * set the default datetime format that would be used by the util function
 * "formatDateTime()" and automatically return a 24hr formatted timestamp.
 * @param settings @object {required}
 */
// function configure(settings = {}) {
//   // instantiate singleton configuration/settings
// }

var index = {
  formValidate: formValidate,
  validate: validate
};

module.exports = index;
